import { createFileRoute } from '@tanstack/react-router';
import { KeysAndIdentitiesPage } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/')({
  component: KeysAndIdentitiesPage,
  staticData: { title: 'API keys and agents · Settings' },
});
